import { render, staticRenderFns } from "./PartnerManager.vue?vue&type=template&id=32f72bbc"
import script from "./PartnerManager.vue?vue&type=script&lang=js"
export * from "./PartnerManager.vue?vue&type=script&lang=js"
import style0 from "./PartnerManager.vue?vue&type=style&index=0&id=32f72bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports